import { render, staticRenderFns } from "./MinisterialPerformance.vue?vue&type=template&id=0500862e&scoped=true"
import script from "./MinisterialPerformance.vue?vue&type=script&lang=ts"
export * from "./MinisterialPerformance.vue?vue&type=script&lang=ts"
import style0 from "./MinisterialPerformance.vue?vue&type=style&index=0&id=0500862e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500862e",
  null
  
)

export default component.exports